/**
 * Payout Routes
 *
 * Route definitions per il modulo payout.
 */
const TheContainer = () => import("@/containers/TheContainer.vue")
const PayoutIndex = () => import("@/domain/payout/index.vue")
const PayoutDetail = () => import("@/domain/payout/PayoutDetail.vue")

export default [
    {
        path: '/payout',
        component: TheContainer,
        meta: {
            perms: ['menu.payout']
        },
        children: [
            {
                path: '',
                name: 'payout',
                component: PayoutIndex,
                meta: {
                    label: 'Pagamenti',
                    breadcrumb: () => [
                        {
                            text: 'Pagamenti'
                            // No 'to' - this is the current page
                        }
                    ]
                },
            },
            {
                path: ':payoutId',
                name: 'payout.detail',
                component: PayoutDetail,
                meta: {
                    label: 'Dettaglio Pagamento',
                    breadcrumb: (context) => {
                        const payout = context.store.getters['payout/payout']
                        const payoutName = payout && payout.id == context.route.params.payoutId
                            ? `Pagamento #${payout.id}`
                            : `Pagamento #${context.route.params.payoutId}`

                        return [
                            {
                                text: 'Pagamenti',
                                to: { name: 'payout' }
                            },
                            {
                                text: payoutName
                                // No 'to' - this is the current page
                            }
                        ]
                    }
                },
            }
        ]
    }
]
